<bmcore-track-item-page [appType]="'PROD-PAGE'" [colorSettingsMode]="colorSettingsMode"> </bmcore-track-item-page>
